import throttle from "./base/_throttle.js";
import focusWithin from "./base/_focus-within.js";
import Header from "./modules/_header.js";
import Flyout from "./modules/_flyout.js";
import SplitHeader from "./modules/_split-header.js";
import Search from "./modules/_search.js";

import "./base/_object-fit-cover.js";

class Scripts {
	constructor() {
		document.addEventListener("DOMContentLoaded", this.ready.bind(this));
		window.addEventListener("resize", throttle(this.resize.bind(this), 25));
		this.resize();
	}

	ready() {
		focusWithin("label, form, fieldset");

		this.header = new Header();
		this.flyout = new Flyout();
		this.splitHeader = new SplitHeader();
		this.search = new Search();
	}

	resize() {
		if (!document.body) {
			return;
		}

		// using this to allow css to know if it should exclude the scroll bar in calc's
		if (window.innerWidth === document.body.clientWidth) {
			document.documentElement.classList.remove("has-scrollbar");
		} else {
			document.documentElement.classList.add("has-scrollbar");
		}
	}
}

export default new Scripts();
